export default "__VITE_ASSET__CXAJrEuK__"